import React, { useState } from 'react';
import { auth, db } from '../firebase';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, updateProfile } from 'firebase/auth';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { useGyerekek } from '../GyerekekContext';

const KOROSZTALYOK = [
  { ertek: '6-8', cimke: '6–8 év' },
  { ertek: '9-11', cimke: '9–11 év' },
  { ertek: '12-14', cimke: '12–14 év' },
];

// A szervered a 3001-es porton fut (server.js: app.listen(3001, ...))
const SZERVER_URL = 'http://localhost:3001';

async function udvozloEmailKuldeseKliens(email, nev) {
  try {
    await fetch(`${SZERVER_URL}/api/udvozlo-email`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, nev }),
    });
  } catch (err) {
    // Az email küldés sikertelensége ne akassza meg a regisztrációt
    console.error('Üdvözlő email küldése sikertelen:', err);
  }
}

function Bejelentkezes({ onKesz }) {
  const { gyerekekHelyiFrissitese } = useGyerekek();
  const [email, setEmail] = useState('');
  const [jelszo, setJelszo] = useState('');
  const [jelszoMegerosites, setJelszoMegerosites] = useState('');
  const [regisztracio, setRegisztracio] = useState(false);
  const [hiba, setHiba] = useState('');
  const [tolt, setTolt] = useState(false);

  // A szülő/törvényes képviselő neve (regisztrációkor) — ez kerül a Firebase
  // Auth displayName mezőjébe, ezt jeleníti meg a Profil oldal fejléce.
  const [szuloNev, setSzuloNev] = useState('');

  // Gyerek profil adatai (regisztrációkor)
  const [gyerekNev, setGyerekNev] = useState('');
  const [gyerekKoroszaly, setGyerekKoroszaly] = useState('6-8');

  // Kötelező jogi nyilatkozatok (mindhárom kell a regisztrációhoz)
  const [felnottNyilatkozat, setFelnottNyilatkozat] = useState(false);
  const [adatkezelesElfogadva, setAdatkezelesElfogadva] = useState(false);
  const [aszfElfogadva, setAszfElfogadva] = useState(false);

  const mindenNyilatkozatElfogadva = felnottNyilatkozat && adatkezelesElfogadva && aszfElfogadva;

  const jelszoErvenyes = (j) => {
    const eleghosszu = j.length >= 8;
    const vanKisbetu = /[a-z]/.test(j);
    const vanNagybetu = /[A-Z]/.test(j);
    const vanSpecialis = /[^A-Za-z0-9]/.test(j);
    return eleghosszu && vanKisbetu && vanNagybetu && vanSpecialis;
  };

  const alapFelhasznaloDokumentumLetrehozasa = async (uid, felhasznaloEmail, szuloNeve, ujGyerek) => {
    const most = serverTimestamp();
    await setDoc(doc(db, 'felhasznalok', uid), {
      email: felhasznaloEmail,
      szuloNeve,
      letrehozva: most,
      // Jogi nyilatkozatok — külön-külön rögzítve, auditálhatóság miatt
      felnottNyilatkozatElfogadva: true,
      felnottNyilatkozatDatuma: most,
      adatkezelesElfogadva: true,
      adatkezelesDatuma: most,
      aszfElfogadva: true,
      aszfDatuma: most,
      gyerekek: [ujGyerek],
    });
  };

  const emailBejelentkezes = async () => {
    setHiba('');

    if (regisztracio) {
      if (!szuloNev.trim()) {
        setHiba('Add meg a neved — így tudjuk, kit köszöntsünk, és ez jelenik meg a profilodon!');
        return;
      }
      if (!gyerekNev.trim()) {
        setHiba('Add meg gyermeked becenevét vagy keresztnevét — teljes nevet nem javasolunk megadni!');
        return;
      }
      if (!jelszoErvenyes(jelszo)) {
        setHiba('A jelszónak legalább 8 karakter hosszúnak kell lennie, tartalmaznia kell kis- és nagybetűt, valamint speciális karaktert!');
        return;
      }
      if (jelszo !== jelszoMegerosites) {
        setHiba('A két jelszó nem egyezik!');
        return;
      }
      if (!felnottNyilatkozat) {
        setHiba('A regisztrációhoz meg kell erősítened, hogy nagykorú vagy, és jogosult vagy szülőként/törvényes képviselőként eljárni!');
        return;
      }
      if (!adatkezelesElfogadva) {
        setHiba('A regisztrációhoz el kell fogadnod az Adatkezelési tájékoztatót!');
        return;
      }
      if (!aszfElfogadva) {
        setHiba('A regisztrációhoz el kell fogadnod az Általános Szerződési Feltételeket (ÁSZF)!');
        return;
      }
    }

    setTolt(true);
    try {
      if (regisztracio) {
        const userCredential = await createUserWithEmailAndPassword(auth, email, jelszo);
        await updateProfile(userCredential.user, { displayName: szuloNev.trim() });
        const ujGyerek = {
         id: `${Date.now()}-${Math.random().toString(36).substring(2, 10)}`,
          nev: gyerekNev.trim(),
          koroszaly: gyerekKoroszaly,
          xp: 0,
          letrehozva: new Date().toISOString(),
        };
        await alapFelhasznaloDokumentumLetrehozasa(userCredential.user.uid, email, szuloNev.trim(), ujGyerek);
        // A GyerekekContext a `felhasznalo` változásra automatikusan újraolvasná
        // a Firestore-t, DE ez a beolvasás versenyhelyzetben lehet a fenti
        // setDoc-kal (előfordulhat, hogy a dokumentum még nem létezik, amikor
        // lefut) — ezért itt közvetlenül, azonnal frissítjük a megosztott
        // állapotot is, hogy a frissen létrehozott gyerek biztosan megjelenjen.
        gyerekekHelyiFrissitese([ujGyerek]);
        udvozloEmailKuldeseKliens(email, null);
      } else {
        await signInWithEmailAndPassword(auth, email, jelszo);
      }
      if (onKesz) onKesz();
    } catch (err) {
      if (err.code === 'auth/email-already-in-use') setHiba('Ez az email cím már használatban van!');
      else if (err.code === 'auth/wrong-password') setHiba('Helytelen jelszó!');
      else if (err.code === 'auth/user-not-found') setHiba('Nem találjuk ezt az email címet!');
      else if (err.code === 'auth/weak-password') setHiba('A jelszónak legalább 6 karakternek kell lennie!');
     else {
  console.error('Regisztrációs hiba:', err);
  setHiba(`Hiba történt: ${err.code || err.message || 'ismeretlen hiba'}`);
}
    }
    setTolt(false);
  };

  return (
    <div style={{background: 'white', borderRadius: '20px', padding: '2.5rem', width: '100%', maxWidth: '420px', boxShadow: '0 20px 60px rgba(0,0,0,0.3)'}}>
      <div style={{textAlign: 'center', marginBottom: '2rem'}}>
        <img src="/NetOkos_log.png" alt="NetOkos" style={{height: '80px', marginBottom: '1rem'}} />
        <h1 style={{fontSize: '24px', fontWeight: '600', color: '#1a73e8', marginBottom: '0.5rem'}}>
          {regisztracio ? 'Regisztráció' : 'Bejelentkezés'}
        </h1>
        <p style={{fontSize: '14px', color: '#888'}}>
          {regisztracio ? 'Hozz létre egy NetOkos fiókot a családodnak!' : 'Üdvözlünk vissza a NetOkoson!'}
        </p>
      </div>

      {regisztracio && (
        <div style={{marginBottom: '1rem'}}>
          <label style={{fontSize: '14px', fontWeight: '500', color: '#333', marginBottom: '6px', display: 'block'}}>
            A te neved (szülő/törvényes képviselő)
          </label>
          <input type="text" value={szuloNev} onChange={e => setSzuloNev(e.target.value)}
            placeholder="pl. Kovács Anna"
            style={{width: '100%', padding: '12px 14px', borderRadius: '10px', border: '1.5px solid #ddd', fontSize: '15px', outline: 'none', boxSizing: 'border-box'}} />
        </div>
      )}

      <div style={{marginBottom: '1rem'}}>
        <label style={{fontSize: '14px', fontWeight: '500', color: '#333', marginBottom: '6px', display: 'block'}}>
          {regisztracio ? 'Szülő email címe' : 'Email cím'}
        </label>
        <input type="email" value={email} onChange={e => setEmail(e.target.value)}
          placeholder="pelda@email.com"
          style={{width: '100%', padding: '12px 14px', borderRadius: '10px', border: '1.5px solid #ddd', fontSize: '15px', outline: 'none', boxSizing: 'border-box'}} />
      </div>

      <div style={{marginBottom: regisztracio ? '0.5rem' : '1.5rem'}}>
        <label style={{fontSize: '14px', fontWeight: '500', color: '#333', marginBottom: '6px', display: 'block'}}>Jelszó</label>
        <input type="password" value={jelszo} onChange={e => setJelszo(e.target.value)}
          placeholder="Minimum 8 karakter"
          style={{width: '100%', padding: '12px 14px', borderRadius: '10px', border: '1.5px solid #ddd', fontSize: '15px', outline: 'none', boxSizing: 'border-box'}} />
      </div>

      {regisztracio && (
        <>
          <p style={{fontSize: '12px', color: '#999', margin: '0 0 1rem'}}>
            Legalább 8 karakter, kis- és nagybetű, valamint speciális karakter (pl. ! ? % @).
          </p>

          <div style={{marginBottom: '1.5rem'}}>
            <label style={{fontSize: '14px', fontWeight: '500', color: '#333', marginBottom: '6px', display: 'block'}}>Jelszó megerősítése</label>
            <input type="password" value={jelszoMegerosites} onChange={e => setJelszoMegerosites(e.target.value)}
              placeholder="Írd be újra a jelszót"
              style={{width: '100%', padding: '12px 14px', borderRadius: '10px', border: '1.5px solid #ddd', fontSize: '15px', outline: 'none', boxSizing: 'border-box'}} />
          </div>
        </>
      )}

      {regisztracio && (
        <>
          <div style={{height: '1px', background: '#eee', margin: '1.25rem 0'}} />

          <div style={{fontSize: '14px', fontWeight: '700', color: '#333', marginBottom: '1rem'}}>
            👶 Gyermeked profilja
          </div>

          <div style={{marginBottom: '1rem'}}>
            <label style={{fontSize: '14px', fontWeight: '500', color: '#333', marginBottom: '6px', display: 'block'}}>Gyermeked beceneve vagy keresztneve</label>
            <input type="text" value={gyerekNev} onChange={e => setGyerekNev(e.target.value)}
              placeholder="pl. Kata"
              style={{width: '100%', padding: '12px 14px', borderRadius: '10px', border: '1.5px solid #ddd', fontSize: '15px', outline: 'none', boxSizing: 'border-box'}} />
            <p style={{fontSize: '12px', color: '#999', marginTop: '6px'}}>
              Javasoljuk, hogy ne a teljes nevet add meg — a becenév vagy keresztnév is elég.
            </p>
          </div>

          <div style={{marginBottom: '1.25rem'}}>
            <label style={{fontSize: '14px', fontWeight: '500', color: '#333', marginBottom: '6px', display: 'block'}}>Korosztály</label>
            <div style={{display: 'flex', gap: '8px'}}>
              {KOROSZTALYOK.map(k => (
                <button key={k.ertek} type="button" onClick={() => setGyerekKoroszaly(k.ertek)}
                  style={{
                    flex: 1, padding: '10px 8px', borderRadius: '10px', fontSize: '13px', fontWeight: '700', cursor: 'pointer',
                    border: gyerekKoroszaly === k.ertek ? '2px solid #1a73e8' : '1.5px solid #ddd',
                    background: gyerekKoroszaly === k.ertek ? '#e3f2fd' : 'white',
                    color: gyerekKoroszaly === k.ertek ? '#1a73e8' : '#555',
                  }}>
                  {k.cimke}
                </button>
              ))}
            </div>
            <p style={{fontSize: '12px', color: '#999', marginTop: '6px'}}>
              Gyermeked csak az itt megadott korosztálynak megfelelő tananyagokat fogja látni.
            </p>
          </div>

          <div style={{height: '1px', background: '#eee', margin: '1.25rem 0'}} />

          <div style={{fontSize: '14px', fontWeight: '700', color: '#333', marginBottom: '1rem'}}>
            📋 Jogi nyilatkozatok
          </div>

          <label style={{display: 'flex', alignItems: 'flex-start', gap: '10px', marginBottom: '1rem', cursor: 'pointer'}}>
            <input type="checkbox" checked={felnottNyilatkozat} onChange={e => setFelnottNyilatkozat(e.target.checked)}
              style={{marginTop: '3px', width: '16px', height: '16px', flexShrink: 0}} />
            <span style={{fontSize: '13px', color: '#555', lineHeight: '1.5'}}>
              Kijelentem, hogy elmúltam 18 éves, és jogosult vagyok szülőként/törvényes képviselőként eljárni a fent megadott gyermek nevében. <strong>Gyermek saját nevében nem regisztrálhat</strong> — a szolgáltatást csak felnőtt hozhatja létre, a gyermek utána a felnőtt felügyelete mellett tanulhat rajta.
            </span>
          </label>

          <label style={{display: 'flex', alignItems: 'flex-start', gap: '10px', marginBottom: '1rem', cursor: 'pointer'}}>
            <input type="checkbox" checked={adatkezelesElfogadva} onChange={e => setAdatkezelesElfogadva(e.target.checked)}
              style={{marginTop: '3px', width: '16px', height: '16px', flexShrink: 0}} />
            <span style={{fontSize: '13px', color: '#555', lineHeight: '1.5'}}>
              Elolvastam és elfogadom az <a href="/adatkezeles" target="_blank" rel="noopener noreferrer" style={{color: '#1a73e8'}}>Adatkezelési tájékoztatót</a>, és szülőként/törvényes képviselőként hozzájárulok gyermekem fent megadott adatainak (becenév, korosztály, tanulási előrehaladás) kezeléséhez a NetOkos platformon.
            </span>
          </label>

          <label style={{display: 'flex', alignItems: 'flex-start', gap: '10px', marginBottom: '1.5rem', cursor: 'pointer'}}>
            <input type="checkbox" checked={aszfElfogadva} onChange={e => setAszfElfogadva(e.target.checked)}
              style={{marginTop: '3px', width: '16px', height: '16px', flexShrink: 0}} />
            <span style={{fontSize: '13px', color: '#555', lineHeight: '1.5'}}>
              Elolvastam és elfogadom az <a href="/aszf" target="_blank" rel="noopener noreferrer" style={{color: '#1a73e8'}}>Általános Szerződési Feltételeket (ÁSZF)</a>.
            </span>
          </label>
        </>
      )}

      {hiba && (
        <div style={{background: '#fce8e6', border: '1px solid #ea4335', borderRadius: '8px', padding: '10px 14px', fontSize: '14px', color: '#ea4335', marginBottom: '1rem'}}>
          ⚠️ {hiba}
        </div>
      )}

      <button onClick={emailBejelentkezes} disabled={tolt || (regisztracio && !mindenNyilatkozatElfogadva)}
        style={{
          width: '100%',
          background: (regisztracio && !mindenNyilatkozatElfogadva) ? '#ccc' : 'linear-gradient(135deg, #1a73e8, #4fc3f7)',
          color: 'white', border: 'none', borderRadius: '12px', padding: '14px', fontSize: '16px', fontWeight: '600',
          cursor: (tolt || (regisztracio && !mindenNyilatkozatElfogadva)) ? 'not-allowed' : 'pointer',
          marginBottom: '1rem',
        }}>
        {tolt ? '⏳ Betöltés...' : regisztracio ? 'Regisztráció' : 'Bejelentkezés'}
      </button>

      <div style={{textAlign: 'center', fontSize: '14px', color: '#888'}}>
        {regisztracio ? 'Már van fiókod?' : 'Még nincs fiókod?'}
        <button onClick={() => { setRegisztracio(!regisztracio); setHiba(''); }}
          style={{background: 'none', border: 'none', color: '#1a73e8', fontWeight: '600', cursor: 'pointer', fontSize: '14px', marginLeft: '4px'}}>
          {regisztracio ? 'Bejelentkezés' : 'Regisztráció'}
        </button>
      </div>
    </div>
  );
}

export default Bejelentkezes;